import { useEffect, useState } from 'react';
import EphanDataService, { DANCE_CLASSES, JUDGE_CATEGORIES } from 'services/EphanDataService';

/**
 * Значення фільтрів реєстру з джерела — ADR-0015.
 *
 * Було: список класів і категорій жив у сервісі як вигаданий «запит», що завжди
 * повертав усі десять класів і всі п'ять категорій. У випадному списку стояли
 * рівні, яких у реєстрі немає, і фільтр за ними давав порожній екран.
 *
 * Стало: `/registry/filters` каже, які рівні справді трапляються, і рахує їх у
 * тому ж обсязі, у якому віддає списки. Підписи лишаються за продуктом —
 * джерело оперує номерами.
 *
 * Збій цього запиту нічого не ламає: тоді показуються всі рівні, як раніше.
 */
export function useRegistryFilters() {
  const [available, setAvailable] = useState(null);

  useEffect(() => {
    let cancelled = false;

    EphanDataService.getRegistryFilters().then(({ result }) => {
      if (!cancelled && result) setAvailable(result);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const keep = (dictionary, values) =>
    Array.isArray(values) && values.length > 0
      ? dictionary.filter((item) => values.includes(item.value))
      : dictionary;

  return {
    danceClasses: keep(DANCE_CLASSES, available?.dancers?.danceClasses),
    judgeCategories: keep(JUDGE_CATEGORIES, available?.judges?.judgeCategories),
  };
}
